import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { PageDataPanelComponent } from '../../shared/page-layout/page-data-panel.component';
import { AccountingComplianceEvent } from '../accounting-compliance.model';

@Component({
    selector: 'app-zatca-compliance-panel',
    standalone: true,
    imports: [CommonModule, ButtonModule, TagModule, PageDataPanelComponent],
    template: `
        <app-page-data-panel title="ZATCA Compliance">
            <div class="compliance-grid">
                <div><strong>Status</strong><p-tag [value]="status || 'PENDING'" [severity]="severity(status)"></p-tag></div>
                <div><strong>Reporting</strong><span>{{ reportingStatus || '-' }}</span></div>
                <div><strong>Clearance</strong><span>{{ clearanceStatus || '-' }}</span></div>
                <div><strong>Retry count</strong><span>{{ retryCount || 0 }}</span></div>
                <div><strong>Submitted at</strong><span>{{ submittedAt | date:'short' }}</span></div>
                <div><strong>Last retry</strong><span>{{ lastRetryAt | date:'short' }}</span></div>
                <div class="wide"><strong>Hash</strong><span>{{ invoiceHash || '-' }}</span></div>
                <div class="wide"><strong>XML / Report</strong><a *ngIf="xmlFileUrl || reportUrl" [href]="xmlFileUrl || reportUrl" target="_blank">Open file</a><span *ngIf="!xmlFileUrl && !reportUrl">-</span></div>
                <div class="wide" *ngIf="errorMessage"><strong>Error</strong><span class="error">{{ errorMessage }}</span></div>
                <div class="wide" *ngIf="qrCodeValue"><strong>QR</strong><textarea readonly>{{ qrCodeValue }}</textarea></div>
            </div>
            <div class="actions">
                <p-button label="Retry ZATCA" icon="pi pi-refresh" severity="warn" [disabled]="retrying" (click)="retry.emit()"></p-button>
            </div>
            <div class="events" *ngIf="events?.length">
                <h4>Retry History</h4>
                <div class="event" *ngFor="let event of events">
                    <span>{{ event.createdAt | date:'short' }}</span>
                    <strong>{{ event.eventType }}</strong>
                    <span>{{ event.status || '-' }}</span>
                    <small>{{ event.errorMessage || '' }}</small>
                </div>
            </div>
        </app-page-data-panel>
    `,
    styles: [`.compliance-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:.75rem}.compliance-grid div{display:flex;flex-direction:column;gap:.25rem;padding:.75rem;border:1px solid #e2e8f0;border-radius:8px}.wide{grid-column:1/-1}.error{color:#b91c1c}textarea{width:100%;min-height:5rem}.actions{margin-top:1rem}.event{display:grid;grid-template-columns:160px 1fr 120px;gap:.75rem;padding:.5rem 0;border-top:1px solid #e2e8f0}`]
})
export class ZatcaCompliancePanelComponent {
    @Input() status?: string;
    @Input() reportingStatus?: string;
    @Input() clearanceStatus?: string;
    @Input() invoiceHash?: string;
    @Input() qrCodeValue?: string;
    @Input() xmlFileUrl?: string;
    @Input() reportUrl?: string;
    @Input() errorMessage?: string;
    @Input() retryCount?: number;
    @Input() submittedAt?: Date;
    @Input() lastRetryAt?: Date;
    @Input() events: AccountingComplianceEvent[] = [];
    @Input() retrying = false;
    @Output() retry = new EventEmitter<void>();

    severity(status?: string) {
        const normalized = (status || '').toUpperCase();
        if (['FAILED', 'ERROR'].includes(normalized)) return 'danger';
        if (['CLEARED', 'REPORTED', 'SUBMITTED', 'PASS'].includes(normalized)) return 'success';
        return 'warning';
    }
}
